import makeSecure from "@/components/MakeSecure";

export default {
  name: "profit-or-loses-percent-in-table",
  components: { makeSecure },
  props: [],
  data() {
    return {};
  },
  computed: {},
  mounted() {},
  methods: {}
};
